import React from 'react';
import PropTypes from 'prop-types';
import SiteNavADesktopLevelA from 'components/SiteNav/SiteNavA/SiteNavADesktop/SiteNavADesktopLevelA';
import SiteNavADesktopLevelB from 'components/SiteNav/SiteNavA/SiteNavADesktop/SiteNavADesktopLevelB';
import SiteNavADesktopLevelC from 'components/SiteNav/SiteNavA/SiteNavADesktop/SiteNavADesktopLevelC';
import SiteNavADesktopLevelD from 'components/SiteNav/SiteNavA/SiteNavADesktop/SiteNavADesktopLevelD';

const SiteNavADesktop = (props) => {
  const {
    levelBSelected = {},
    levelCItems = [],
    levelDItems = [],
  } = props;

  return (
    <div>
      <SiteNavADesktopLevelA {...props} />
      {levelBSelected.heading && !levelBSelected.hidden &&
        <SiteNavADesktopLevelB
          heading={levelBSelected.heading}
          subHeading={levelBSelected.subHeading}
          href={levelBSelected.href}
          target={levelBSelected.target}
        />}
      {levelCItems.length > 0 &&
        <SiteNavADesktopLevelC items={levelCItems} />}
      {levelDItems.length > 0 &&
        <SiteNavADesktopLevelD items={levelDItems} />}
    </div>
  );
};

SiteNavADesktop.propTypes = {
  levelBSelected: PropTypes.object,
  levelCItems: PropTypes.array,
  levelDItems: PropTypes.array,
};

export default SiteNavADesktop;
